'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unsubscribe = exports.subscribe = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; }; /**
                                                                                                                                                                                                                                                   * Imports
                                                                                                                                                                                                                                                   */

var _foreach = require('@f/foreach');

var _foreach2 = _interopRequireDefault(_foreach);

var _getProp = require('@f/get-prop');

var _getProp2 = _interopRequireDefault(_getProp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Action types
 */

var SUBSCRIBE = '@@redux-subscribe/subscribe';
var UNSUBSCRIBE = '@@redux-subscribe/unsubscribe';

/**
 * redux-subscribe
 */

function subscribeMiddleware(_ref) {
  var dispatch = _ref.dispatch;
  var getState = _ref.getState;

  var paths = [];
  var subscriptions = {};

  return function (next) {
    return function (action) {
      switch (action.type) {
        case SUBSCRIBE:
          {
            var _action$payload = action.payload;
            var path = _action$payload.path;
            var key = _action$payload.key;
            var fn = _action$payload.fn;

            subscriptions[path] = subscriptions[path] || {};
            subscriptions[path][key] = fn;
            if (paths.indexOf(path) === -1) {
              paths.push(path);
            }
            break;
          }
        case UNSUBSCRIBE:
          {
            var _action$payload2 = action.payload;
            var path = _action$payload2.path;
            var key = _action$payload2.key;

            var subs = subscriptions[path];

            if (subs) {
              delete subs[key];
              if (Object.keys(subs).length === 0) {
                delete subscriptions[path];
                paths.splice(paths.indexOf(path), 1);
              }
            }

            break;
          }
        default:
          {
            var _ret = function () {
              var prevState = getState();
              var result = next(action);
              var nextState = getState();

              (0, _foreach2.default)(function (path) {
                var prev = (0, _getProp2.default)(path, prevState);
                var next = (0, _getProp2.default)(path, nextState);

                if (prev !== next) {
                  (0, _foreach2.default)(function (fn) {
                    return dispatch(fn({ path: path, prev: prev, next: next }));
                  }, subscriptions[path]);
                }
              }, paths);

              return {
                v: result
              };
            }();

            if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
          }
      }
    };
  };
}

/**
 * Action creators
 */

function subscribe(path, key, fn) {
  return {
    type: SUBSCRIBE,
    payload: { path: path, key: key, fn: fn }
  };
}

function unsubscribe(path, key) {
  return {
    type: UNSUBSCRIBE,
    payload: { path: path, key: key }
  };
}

/**
 * Exports
 */

exports.default = subscribeMiddleware;
exports.subscribe = subscribe;
exports.unsubscribe = unsubscribe;


//////////////////
// WEBPACK FOOTER
// ./~/redux-subscribe/lib/index.js
// module id = ./node_modules/redux-subscribe/lib/index.js
// module chunks = portal incabStudent incabManager incabTeacher incabHelpdesk marathons